import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import payementService from './payementService'


const initialState = {
  payement: null,
  client: null,
  moyens: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  isClientError: false,
  isClientSuccess: false,
  isClientLoading: false,
  message: '',
}

export const createClient = createAsyncThunk(
    'payement/create-client',
    async (data, thunkAPI) => {
      try {
        return await payementService.createClient(data)
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
        return thunkAPI.rejectWithValue(message)
      }
    }
)
  
export const getModeDePaiement = createAsyncThunk(
    'payement/mode-paiement',
    async (data, thunkAPI) => {
      try {
        return await payementService.getMoyenPaiementParPays(data)
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
        return thunkAPI.rejectWithValue(message)
      }
    }
)
  
export const executePayement = createAsyncThunk(
    'payement/paiement',
    async (data, thunkAPI) => {
      try {
        return await payementService.payementCreate(data)
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
        return thunkAPI.rejectWithValue(message)
      }
    }
)
  


export const payementSlice = createSlice({
    name: 'payement',
    initialState,
    reducers: {
      reset: (state) => {
        state.isLoading = false
        state.isSuccess = false
        state.isError = false
        state.isClientLoading = false
        state.isClientSuccess = false
        state.isClientError = false
        state.message = ''
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(createClient.pending, (state) => {
            state.isClientLoading = true
        })
        .addCase(createClient.fulfilled, (state, action) => {
            state.isClientLoading = false
            state.isClientSuccess = true
            state.client = action.payload
        })
        .addCase(createClient.rejected, (state, action) => {
            state.isClientLoading = false
            state.isClientError = true
            state.message = action.payload
            state.client = null
        })
        .addCase(getModeDePaiement.pending, (state) => {
            state.isLoading = true
        })
        .addCase(getModeDePaiement.fulfilled, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.moyens = action.payload
        })
        .addCase(getModeDePaiement.rejected, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.message = action.payload
            state.moyens = null
        })
        .addCase(executePayement.pending, (state) => {
            state.isLoading = true
        })
        .addCase(executePayement.fulfilled, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.payement = action.payload
        })
        .addCase(executePayement.rejected, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.message = action.payload
            state.payement = null
        })
    },
})
  
export const { reset } = payementSlice.actions
export default payementSlice.reducer